import React from 'react'
import { getGpBandChipStyle } from 'src/utils/recipeGp'

const baseStyle = {
  fontWeight: 600,
  fontSize: '12px',
  padding: '2px 6px',
  borderRadius: '4px',
  display: 'inline-block',
}

const GpBandChip = ({ gp, children, style }) => {
  const bandStyle = getGpBandChipStyle(gp)

  return (
    <span style={{ ...baseStyle, ...bandStyle, ...style }}>{children}</span>
  )
}

export default GpBandChip
